import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { ROUTES, insertIdtoUrl } from 'constants/Routes';

const DEFAULT_PAGE_SIZE = 20;

class SurveyTemplateTable extends Component {
  constructor() {
    super();
    this.state = {
      value: '',
    };
  }

  handleChange = event => {
    this.setState({ value: event.target.value });
  };

  render() {
    const { surveyTemplates, deleteSurveyTemplate, searchText } = this.props;

    let searchedTemplates = surveyTemplates.slice();
    if (searchText.length > 0) {
      searchedTemplates = searchedTemplates.filter(biz =>
        biz.name.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    const columns = [
      {
        Header: 'Name',
        id: 'name',
        sortable: true,
        accessor: 'name',
        width: 500,
      },
      {
        Header: 'Businesses',
        Cell: ({ original }) => (
          <NavLink
            className="btn btn-outline-secondary btn-sm"
            to={insertIdtoUrl(ROUTES.BUSINESS_FILTER, original.id)}
          >
            View all{' '}
            <span className="badge badge-pill badge-secondary">
              {original.business_count}
            </span>
          </NavLink>
        ),
      },
      {
        Header: 'Questions',
        Cell: ({ original }) => (
          <NavLink
            className="btn btn-outline-secondary btn-sm"
            to={insertIdtoUrl(ROUTES.CATEGORIES_QUESTIONS, original.id)}
          >
            Edit Questions
            <span className="ml-2 badge badge-pill badge-secondary">
              {original.question_count}
            </span>
          </NavLink>
        ),
      },
      {
        Header: 'Actions',
        sortable: false,
        Cell: ({ original }) => (
          <React.Fragment>
            <NavLink
              className="circular-icon icon-check ml-0"
              to={ROUTES.EDIT_SURVEY_TEMPLATE.replace(
                ':surveyTemplateId',
                original.id
              )}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </NavLink>
            <span
              className="circular-icon icon-cross"
              onClick={deleteSurveyTemplate.bind(
                this,
                original.id,
                original.name,
                original.business_count,
                original.question_count
              )}
            >
              <FontAwesomeIcon icon="trash-alt" />
            </span>
          </React.Fragment>
        ),
      },
    ];

    const pageSize =
      searchedTemplates.length === 0 ||
      searchedTemplates.length > DEFAULT_PAGE_SIZE
        ? DEFAULT_PAGE_SIZE
        : searchedTemplates.length;
    const minRows = searchedTemplates.length ? 0 : 2;

    return (
      <div>
        <ReactTable
          className="styled-box-shadow bg-white"
          data={searchedTemplates}
          columns={columns}
          resizable={false}
          sortable={false}
          minRows={minRows}
          showPageSizeOptions={false}
          defaultPageSize={pageSize}
        />
      </div>
    );
  }
}

SurveyTemplateTable.defaultProps = {
  surveyTemplates: [],
  deleteSurveyTemplate: () => {},
  searchText: '',
};

SurveyTemplateTable.propTypes = {
  surveyTemplates: PropTypes.array,
  deleteSurveyTemplate: PropTypes.func,
  searchText: PropTypes.string,
};

export default SurveyTemplateTable;



// WEBPACK FOOTER //
// ./src/components/surveyTemplate/SurveyTemplateTable.js